import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';

export const ZodCustomHtmlWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    html: z.string(),
});

export type CustomHtmlWidgetConfigurationDetails = z.infer<
    typeof ZodCustomHtmlWidgetConfigurationDetails
>;

export const ZodCustomHtmlWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.CUSTOM_HTML),
    config: ZodCustomHtmlWidgetConfigurationDetails,
});

export type CustomHtmlWidgetConfiguration = z.infer<typeof ZodCustomHtmlWidgetConfiguration>;
